import { mergeRefs } from '@chakra-ui/react-utils';
import {
  chakra,
  type ChakraProps,
  forwardRef,
  useModalStyles,
} from '@chakra-ui/react-v2';
import { useMemo } from 'react';

import { useHeaderActionsWidth } from '../useHeaderActionsWidth';
import {
  MODAL_HEADER_ACTIONS_ATTRIBUTE,
  MODAL_HEADER_ACTIONS_WIDTH_VAR,
} from './const';

export type ModalHeaderActionsProps = ChakraProps;

/**
 * Top-right slot of a ModalHeader for extra controls (the close button is
 * handled separately by the modal theme). It measures itself and publishes its
 * width to the header, so the header text and overline never run under it.
 * Must be rendered inside a ModalHeader.
 */
export const ModalHeaderActions = forwardRef<ModalHeaderActionsProps, 'div'>(
  (props, forwardedRef) => {
    const { headerActions: headerActionsStyles } = useModalStyles();
    const elementRef = useHeaderActionsWidth<HTMLDivElement>(
      MODAL_HEADER_ACTIONS_WIDTH_VAR,
    );
    const ref = useMemo(
      () => mergeRefs(forwardedRef, elementRef),
      [forwardedRef, elementRef],
    );

    return (
      <chakra.div
        ref={ref}
        {...{ [MODAL_HEADER_ACTIONS_ATTRIBUTE]: '' }}
        __css={headerActionsStyles}
        {...props}
      />
    );
  },
);
ModalHeaderActions.displayName = 'ModalHeaderActions';
